import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PremiumPackagesBlockData from '../../../Models/Content/PremiumPackagesBlockData';
import PremiumPackagesHolder from './PremiumPackagesHolder/PremiumPackagesHolder';
export default class PremiumPackagesBlock extends EpiComponent<PremiumPackagesBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (  
          <PremiumPackagesHolder iContent={this.props.data}/>
      )
    }
}